import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { accessToken } from '../../../../configuration/tokenHandling/accessToken';
import { getApiTags } from '../../config/pathURL/config';
import { decodeJson, transformRtkQueryError } from '../api';
import { type ApiTags, ApiTagsCodec } from './tag.types';

export const tagApiSlice = createApi({
    reducerPath: 'tagApi',
    baseQuery: fetchBaseQuery({
        prepareHeaders: headers => {
            const token = accessToken.getAccessToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: builder => ({
        getTags: builder.query<ApiTags['items'], void>({
            query: () => `${getApiTags()}/tags`,
            transformResponse: response => decodeJson(ApiTagsCodec)(response).items,
            transformErrorResponse: response => transformRtkQueryError(response, [401]),
        }),
    }),
});

export const { useGetTagsQuery } = tagApiSlice;
